var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85256 10.422C7.85256 8.45997 9.44313 6.8694 11.4052 6.8694C13.3673 6.8694 14.9578 8.45997 14.9578 10.422C14.9578 12.3841 13.3673 13.9747 11.4052 13.9747C9.44313 13.9747 7.85256 12.3841 7.85256 10.422ZM11.4052 4.50098C8.13508 4.50098 5.48413 7.15192 5.48413 10.422C5.48413 13.6921 8.13508 16.3431 11.4052 16.3431C12.612 16.3431 13.7345 15.9821 14.6705 15.3621L18.4625 19.1542C18.925 19.6166 19.6749 19.6166 20.1373 19.1542C20.5997 18.6917 20.5997 17.9419 20.1373 17.4794L16.3453 13.6874C16.9652 12.7513 17.3263 11.6288 17.3263 10.422C17.3263 7.15192 14.6753 4.50098 11.4052 4.50098Z",
    fill: "#172B4D",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchs);
export default __webpack_public_path__ + "static/media/searchs.afaf2fedd9af0158533606d5e984314d.svg";
export { ForwardRef as ReactComponent };